// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__RGzXy","col":"styles_col__Je4VJ"};